/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'

import { Avatar, Paragraph, Title } from '@components/atoms'
import { SwitchBase } from '@components/atoms/Switch'
import { ListHistory } from '@components/molecules'
import {
	WeatherMoon20Regular,
	LockClosed20Regular,
} from '@fluentui/react-icons'
import { dashboardAPI } from '@services/DashboardAPI'
import { modalCreators } from '@store/ducks/modal'
import { themeCreators } from '@store/ducks/theme'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import moment from 'moment'

import { DeleteAccount } from './Modals/DeleteAccount'
import { EditAddress } from './Modals/EditAddress'
import { EditInfo } from './Modals/EditInfo'
import { EditPassword } from './Modals/EditPassword'
import { ShowClasses } from './Modals/ShowClass'
import {
	InfoMe,
	InfoPersonal,
	SettingsStyles,
	InfoPersonalHeader,
	InfoPersonalBody,
	ChangePassword,
	ChangeTheme,
	/* 	DeleteBox, */
	Class,
	ContainerLogs,
} from './style'

const {
	container,
	title,
	containerInfos,
	containerContent,
	icon,
	containerPlus,
	buttonUnderline,
} = SettingsStyles

export const Settings = () => {
	const dispatch = useAppDispatch()
	const { theme } = useAppSelector((state) => state)

	const { data } = dashboardAPI.useListMeQuery()

	const [getActivityHistory, { data: dataActivity }] =
		dashboardAPI.useGetActivityHistoryMutation()

	useEffect(() => {
		getActivityHistory()
	}, [getActivityHistory])

	return (
		<div className={container()}>
			<div>
				<div className={title()}>
					<Title variant='h1' color='$neutral160'>
						Meu perfil
					</Title>
				</div>
			</div>
			<div className={containerContent()}>
				<div className={containerInfos()}>
					<InfoMe>
						<Avatar
							src={data?.imageUrl || ''}
							alt={data?.name || ''}
							name={data?.name || ''}
							showName={false}
							changeImage
						/>

						<div style={{ width: '100%' }}>
							<h4>{data?.name || ''}</h4>
							<hr />
							<Paragraph paragraphType='p1' css={{ color: '$neutral90' }}>
								{data?.email}
							</Paragraph>
						</div>
					</InfoMe>
					<InfoPersonal>
						<InfoPersonalHeader>
							<Title variant='h6' color='$neutral100'>
								Informações pessoais
							</Title>
							<div
								onClick={() =>
									dispatch(
										modalCreators.openModal({
											name: 'editInfo',
											modalInfo: data,
										})
									)
								}
							>
								Alterar
							</div>
						</InfoPersonalHeader>
						<InfoPersonalBody>
							<p>{data?.name}</p>
							<p>{data?.email}</p>
							<p>{data?.cpfCnpj || 'Cpf não informado'}</p>
							<p>{data?.whatsapp || 'Whats não informado'}</p>
							<p>{data?.phone || 'Telefone não informado'}</p>
							<p>{moment.utc(data?.birthdate).format('DD/MM/YYYY')}</p>
						</InfoPersonalBody>
					</InfoPersonal>
					<InfoPersonal>
						<InfoPersonalHeader>
							<Title variant='h6' color='$neutral100'>
								Endereço
							</Title>
							<div
								onClick={() =>
									dispatch(
										modalCreators.openModal({
											name: 'editAddress',
											modalInfo: data,
										})
									)
								}
							>
								Alterar
							</div>
						</InfoPersonalHeader>
						<InfoPersonalBody>
							<p>{data?.address?.cep || 'Cep não informado'}</p>
							<p>{data?.address?.street || 'Endereço não informado'}</p>
							<p>{data?.address?.number || 'Numero não informado'}</p>
							<p>{data?.address?.district || 'Bairro não informado'}</p>
							<p>{data?.address?.city || 'Cidade não informada'}</p>
							<p>{data?.address?.uf || 'UF não informado'}</p>
						</InfoPersonalBody>
					</InfoPersonal>
				</div>
				<div className={containerPlus()}>
					<Class>
						<Paragraph paragraphType='p1' css={{ color: '$neutral100' }}>
							Turmas
						</Paragraph>

						<div
							onClick={() =>
								dispatch(
									modalCreators.openModal({
										name: 'showClasses',
										modalInfo: data,
									})
								)
							}
						>
							Ver mais
						</div>
					</Class>
					<Class>
						<Paragraph paragraphType='p1' css={{ color: '$neutral100' }}>
							Histórico de atividade
						</Paragraph>

						<Link to='/meu-perfil/histórico-de-atividade'>
							<div>Ver histórico de atividade completo</div>
						</Link>
					</Class>
					<ChangePassword className={icon()}>
						<div style={{ display: 'flex', gap: '8px' }}>
							<LockClosed20Regular width={14} height={16} />
							<Paragraph paragraphType='p1' css={{ color: '$neutral100' }}>
								Alterar senha
							</Paragraph>
						</div>

						<button
							type='button'
							className={buttonUnderline()}
							onClick={() =>
								dispatch(
									modalCreators.openModal({
										name: 'editPassword',
									})
								)
							}
						>
							Alterar
						</button>
					</ChangePassword>
					<ChangeTheme>
						<div style={{ display: 'flex', gap: '8px' }}>
							<WeatherMoon20Regular />
							<Paragraph paragraphType='p1' css={{ color: '$neutral100' }}>
								Modo escuro
							</Paragraph>
						</div>
						<SwitchBase
							enabled={theme.value === 'light'}
							setEnabled={() => {
								dispatch(
									themeCreators.setTheme(
										theme.value === 'dark' ? 'light' : 'dark'
									)
								)
							}}
						/>
					</ChangeTheme>
					<ContainerLogs>
						<div className='contaier-log-desc'>
							<Title variant='h3' color='$neutral130'>
								Últimas 3 atividades
							</Title>

							<Link to='/meu-perfil/histórico-de-atividade'>
								<Paragraph
									paragraphType='p1'
									css={{
										color: '$blue20',
										textDecorationLine: 'underline',
										cursor: 'pointer',
									}}
								>
									Ver histórico de atividade completo
								</Paragraph>
							</Link>
						</div>
						<ListHistory
							list={dataActivity ? dataActivity.slice(0, 3) : []}
							isProfile
						/>
					</ContainerLogs>
					{/* <DeleteBox
						onClick={() =>
							dispatch(
								modalCreators.openModal({
									name: 'deleteAccount',
								})
							)
						}
					>
						<span>Excluir conta</span>
					</DeleteBox> */}
				</div>
			</div>
			<DeleteAccount />
			<EditPassword />
			<EditAddress />
			<EditInfo />
			<ShowClasses />
		</div>
	)
}
